import * as React from "react";
import PropTypes from "prop-types";
import SnazzyButtonLink from "Components/universal/SnazzyButtonLink";
import config from "Config/config";

const LearnMoreBtn = ({ textContent, href }) => {
  return (
    <SnazzyButtonLink href={href}>
      <span className="px-3 text-uppercase">{textContent}</span>
    </SnazzyButtonLink>
  );
};

LearnMoreBtn.propTypes = {
  textContent: PropTypes.string,
  href: PropTypes.string,
};
LearnMoreBtn.defaultProps = {
  textContent: "Learn More",
  href: config.TYPEFORM_URLS.advisors || "#",
};

export default LearnMoreBtn;
